<template>
    <div>
        <b-container fluid class="header">
            <el-container class="text-center">
                <el-steps :active="active" align-center class="payment-steps">
                    <el-step :title="$t('reservation.step_1')" icon="is_process"></el-step>
                    <el-step :title="$t('reservation.step_2')" icon="is_process"></el-step>
                    <el-step :title="$t('reservation.step_3')" icon="is_process"></el-step>
                </el-steps>
            </el-container>
        </b-container>

        <b-container class="payment-main">
            <p v-if="active == 0" class="back-to">
                <a :href="previousUrl" class>{{ $t('reservation.back')}} {{renderData.project.name}}</a>
            </p>
            <p v-if="active == 1" class="back-to">
                <a @click=" active = 0" class>{{ $t('reservation.backToUnit')}}</a>
            </p>

            <el-row v-if="active != 3">
                <el-col class="layout_left" :xs="24" :sm="12" :md="16" :lg="16" :xl="16">
                    <reservation-select-unit v-if="active == 0" @handleChange="receiveChanges"></reservation-select-unit>
                    <reservation-payment
                        v-if="active == 1"
                        @payment="payment_change"
                        :paymentField="paymentField"
                        v-bind:cardError="cardError"
                        v-on:update:cardError="cardError = $event"
                    ></reservation-payment>
                </el-col>
                <el-col class="layout_right sidebar" :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
                    <h3>{{ $t('reservation.unitReservation')}}</h3>
                    <div class="side-box">
                        <div class="box-title clearfix">
                            <div class="fl">
                                <p>{{renderData.project.name}} - {{renderData.project.region_name}}</p>
                                <span>{{(unit_type && unit_type.label) || renderData.unit_label}}</span>
                            </div>
                            <div class="fr hidden-sm-and-down">
                                <img :src="renderData.project.picture" alt="project picture">
                            </div>
                        </div>
                        <div class="box-detail">
                            <!-- <div class="bt-line clearfix">
                <div class="detail-hint">
                  {{ $t('reservation.waiver')}}
                <span>{{ $t('reservation.waiver_1')}}</span>
                  <div class="icon_question">
                    <span>{{ $t('reservation.waiver_msg')}}</span>
                  </div>
                </div>
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
                  <el-form-item prop="code" class="fl">
                    <input
                      v-model="ruleForm.code"
                      type="text"
                      :placeholder="$tc('reservation.enterWaiver')"
                    >
                  </el-form-item>
                  <el-form-item class="fr">
                    <el-button type="button" @click="submitForm('ruleForm')">{{ $t('reservation.apply')}}</el-button>
                  </el-form-item>
                </el-form>
                            </div>-->
                            <!-- v-if="isVIP" -->
                            <div class="bt-line subtotal">
                                <div v-if="!has_vaild_code" class="normal_subtotal clearfix">
                                    <div class="fl">
                                        <p>{{ $t('reservation.subTotal')}}</p>
                                    </div>
                                    <div class="fr">
                                        <p
                                            class="strong"
                                        >{{renderData.amount_currency}} {{renderData.amount | NumFormat}}</p>
                                    </div>
                                </div>
                                <div v-else-if="has_vaild_code" class="reduce_subtotal">
                                    <div class="clearfix">
                                        <div class="fl">
                                            <p>{{ $t('reservation.subTotal')}}</p>
                                        </div>
                                        <div class="fr">
                                            <p
                                                class="strong"
                                            >{{renderData.amount_currency}} {{renderData.amount | NumFormat}}</p>
                                        </div>
                                    </div>
                                    <div class="clearfix reduce_price">
                                        <div class="fl">{{ $t('reservation.reservationWaiver')}}</div>
                                        <div
                                            class="fr strong"
                                        >- {{renderData.amount_currency}} {{renderData.amount | NumFormat}}</div>
                                    </div>
                                    <div class="clearfix">
                                        <div class="fr">
                                            <span>{{ $t('reservation.remove')}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="bt-line total clearfix">
                                <div class="fl">
                                    <p>{{ $t('reservation.total')}}</p>
                                </div>
                                <div class="fr">
                                    <p
                                        class="strong"
                                    >{{renderData.final_amount_currency}} {{renderData.final_amount | NumFormat}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="box-info">
                            <div class="info-box">
                                <div v-if="!has_vaild_code" class="clearfix">
                                    <div class="fl">
                                        <h5>{{ $t('reservation.used')}}</h5>
                                        <p>
                                            {{ $t('reservation.rApplied')}}
                                            <span>{{ $t('reservation.rApplied_1')}}</span>.
                                        </p>
                                    </div>
                                    <div class="fr">
                                        <i></i>
                                    </div>
                                </div>
                                <div v-else-if="has_vaild_code" class="clearfix">
                                    <div class="fl no_fee">
                                        <h5>{{ $t('reservation.noReservation')}}</h5>
                                        <p>
                                            {{ $t('reservation.free')}}
                                            <span>{{ $t('reservation.free_1')}}</span>
                                            {{ $t('reservation.symbol')}}
                                        </p>
                                    </div>
                                    <div class="fr">
                                        <i></i>
                                    </div>
                                </div>
                            </div>
                            <p class="info-hint">{{ $t('reservation.purchase')}}</p>
                        </div>
                    </div>
                    <div class="next">
                        <el-button v-if="active == 0" @click="next">{{ $t('reservation.next')}}</el-button>
                        <el-button
                            type="submit"
                            v-bind:disabled="cardError || this.disabledPaymentSubmit"
                            name="payment-form"
                            v-if="active == 1"
                            @click="reserve"
                            class="reserve"
                        >{{ $t('reservation.reserve')}}</el-button>
                    </div>
                    <div class="privacy_policy" v-if="active == 1">
                        <p>{{ $t('reservation.privacy1')}}</p>
                        <p>
                            <a>{{ $t('reservation.privacy2')}}</a>
                            {{ $t('reservation.privacy2_1')}}
                            <a>{{ $t('reservation.privacy2_2')}}</a>
                        </p>
                    </div>
                </el-col>
            </el-row>

            <reservation-confirm :successUrl="$root.successUrl" v-if="active == 3"></reservation-confirm>
        </b-container>
    </div>
</template>

<script>
import ReservationSelectUnit from "@/components/ReservationSelectUnit";
import ReservationPayment from "@/components/ReservationPayment";
import ReservationConfirm from "@/components/ReservationConfirm";

export default {
    data() {
        return {
            active: 0,
            paymentField: {
                clicked: 0,
                payment_id: undefined
            },
            cardError: true,
            disabledPaymentSubmit: false,
            has_vaild_code: false,
            unit_type: {
                id: "",
                label: ""
            },
            payment_status: {
                payment_way: "",
                paymentSuccess: undefined
            },
            renderData: {},
            ruleForm: {
                code: ""
            },
            rules: {
                code: [
                    {
                        message: "Please use a valid reservation waiver.",
                        trigger: "blur"
                    },
                    {
                        min: 6,
                        max: 10,
                        message: "Should be at 6 - 10 characters.",
                        trigger: "blur",
                        required: true
                    }
                ]
            }
        };
    },

    beforeMount() {
        this.previousUrl = this.$root.previousUrl;
        this.project = this.$root.project;
        this.apiReservation = this.$root.apiReservation;
        this.renderData = this.$root.reservation;
    },

    methods: {
        scrollToTop() {
            window.scroll({
                top: 0,
                behavior: "smooth"
            });
        },

        next() {
            if (
                this.active == 0 &&
                (this.unit_type.id == "" ||
                    this.unit_type.id == undefined ||
                    this.unit_type.id == null)
            ) {
                alert(this.$t("reservation.selectHint"));
                return;
            } else {
                this.$http
                    .post(this.apiReservation, {
                        project: this.project,
                        unit_type_id: this.unit_type.id,
                        promotion:
                            this.ruleForm.code == ""
                                ? undefined
                                : this.ruleForm.code
                    })
                    .then(resp => {
                        this.renderData = resp.data;
                        this.paymentField.payment_id = resp.data.id;
                        this.scrollToTop();
                        if (this.active++ > 3) return;
                    });
            }
        },

        reserve() {
            if (this.active == 1 && this.payment_status.payment_way === "3") {
                this.disabledPaymentSubmit = true;
                this.paymentField.clicked++;
                this.scrollToTop();
            }
        },

        receiveChanges(data) {
            this.unit_type.id = data.id;
            this.unit_type.label = data.label;
        },

        payment_change(data) {
            this.payment_status.payment_way = data.payment_way;
            this.payment_status.paymentSuccess = data.paymentSuccess;
            if (this.payment_status.paymentSuccess) {
                this.active += 2;
            }
        },

        submitForm(formName) {
            //  let loading = this.$loading({
            //     lock: true,
            //     target: ".payment-main",
            //     text: 'Validating..',
            //     spinner: 'el-icon-loading',
            // color: '#3b6bbf',
            //     background: 'rgba(255, 255, 255, 0.8)'
            // });

            if (this.ruleForm.code == "") {
                return;
            }

            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.$http
                        .post(this.apiReservation + "?preview", {
                            project: this.project,
                            promotion:
                                this.ruleForm.code == ""
                                    ? undefined
                                    : this.ruleForm.code,
                            unit_type_id: this.unit_type_id
                        })
                        .then(resp => {
                            // this.$message.success("Congratulations! It's valid.");
                            // assign data
                            this.renderData = resp.data;
                            // tell the elements we got reduce
                            this.has_vaild_code = true;
                            // we don't use loading for now, because the request is too quickly
                            // loading.close();
                        });
                } else {
                    // loading.close();
                    // this.$message.error('The Reservation Waiver number does not exist.');
                    return false;
                }
            });
        },

        goBack() {
            window.history.length > 1
                ? this.$router.go(-1)
                : this.$router.push("/");
            this.scrollToTop();
        }
    },

    filters: {
        NumFormat: function(val) {
            if (!val) return "0";
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
    },

    components: {
        ReservationSelectUnit,
        ReservationPayment,
        ReservationConfirm
    }
};
</script>

<style lang="css" scoped>
.header {
    height: 1.23rem;
    padding: 0.33rem 0 0.35rem;
    background-color: rgb(246, 249, 252);
}
.payment-steps {
    font-family: GothamMedium;
    width: 7.5rem;
    margin: 0 auto;
}

.payment-steps >>> .el-step__icon-inner {
    background: url("../../../website_20/static/img/stacked-group-payment.svg")
        no-repeat;
    background-position: -176px -10px;
    width: 26px;
    height: 26px;
    background-color: transparent;
}

.payment-steps >>> .el-step__head.is-finish .is_process {
    background-position: -217px -10px;
}

.payment-steps >>> .el-step__head.is-wait .el-step__icon-inner {
    background-position: -135px -10px;
}

.payment-steps >>> .el-step__head.is-finish .el-step__line,
.payment-steps
    >>> .el-step__head.is-finish
    .el-step__line
    .el-step__head.is-finish {
    color: #3b6bbf;
    background-color: #3b6bbf;
    border-color: #3b6bbf;
}

.payment-steps >>> .el-step__title.is-process {
    font-size: 16px;
    font-weight: 500;
    color: #3b6bbf;
}
.payment-steps >>> .el-step__title.is-finish {
    font-size: 16px;
    font-weight: 500;
    color: #9b9b9b;
}

.payment-steps >>> .el-step__line {
    height: 4px;
}
.payment-steps >>> .is-icon {
    width: 26px;
    height: 26px;
    background-color: transparent;
}

.payment-main {
    padding: 25px 0;
}
.payment-main .back-to {
    cursor: pointer;
    font-size: 16px;
    color: #3b6bbf;
    margin-bottom: 30px;
}
.payment-main .back-to a {
    font-family: GothamBook;
    color: inherit;
    text-decoration: none;
}
.payment-main .back-to a:hover {
    color: #123b82;
}

.payment-main .back-to:before {
    content: "";
    display: inline-block;
    width: 15px;
    height: 14px;
    margin-right: 9px;
    background: #000;
    background: url("../../../website_20/static/img/stacked-group-payment.svg")
        no-repeat;
    background-position: 0px -15px;
}
.payment-main >>> h3 {
    font-family: GothamBold;
    height: 24px;
    font-size: 22px;
    font-weight: bold;
    line-height: 24px;
    color: #0d253f;
    margin-bottom: 4px;
    margin-top: 0;
}
.payment-main >>> .hint {
    height: auto;
    font-family: OpenSans;
    font-size: 14px;
    line-height: 18px;
    color: #666;
    margin-bottom: 20px;
}
.sidebar h3 {
    margin-top: 22px;
    font-family: GothamBook;
    font-size: 22px;
    font-weight: normal;
    margin-bottom: 20px;
    letter-spacing: 0.3px;
    color: rgb(51, 51, 51);
}
.sidebar .side-box,
.sidebar .next {
    /* width: 370px; */
}
.sidebar .side-box {
    padding: 35px 33px 21px;
    /* max-width: 370px; */
    box-sizing: border-box;
    box-shadow: 0 2px 10px 0 rgba(155, 155, 155, 0.5);
    margin-bottom: 24px;
    z-index: 10;
    overflow: hidden;
    border-radius: 6px;
}
.sidebar .side-box .box-title {
    padding-bottom: 20px;
    border-bottom: 1px solid #d8d8d8;
}
.sidebar .side-box .box-title p {
    width: 1.8rem;
    font-size: 16px;
    margin-bottom: 12px;
    line-height: 1.5;
    color: rgb(0, 0, 0);
}
.sidebar .side-box .box-title span {
    font-family: GothamBold;
    font-size: 14px;
    font-weight: bold;
    line-height: 1.14;
    color: rgb(155, 155, 155);
}
.sidebar .side-box .box-title img {
    border-radius: 3px;
    width: 88px;
    height: 88px;
    object-fit: cover;
}
.sidebar .side-box .box-detail .bt-line {
    border-bottom: 1px solid #d8d8d8;
    padding: 20px 0;
}
/* .sidebar .side-box .box-detail .bt-line:first-child{
    padding-bottom: 0;
} */

.sidebar .side-box .box-detail .detail-hint {
    margin-bottom: 20px;
    font-family: OpenSans;
    font-size: 14px;
    line-height: 1.71;
    color: rgb(27, 33, 37);
    position: relative;
    display: inline-block;
}
.sidebar .side-box .box-detail .detail-hint .icon_question {
    display: inline-block;
    right: -28px;
    top: 4px;
    position: absolute;
    background: url("../../../website_20/static/img/stacked-group-payment.svg")
        no-repeat;
    background-position: -725px -15px;
    width: 15px;
    height: 15px;
}

.sidebar .side-box .box-detail .detail-hint .icon_question:hover span {
    display: block;
}

.sidebar .side-box .box-detail .detail-hint .icon_question span {
    display: none;
    position: absolute;
    box-sizing: border-box;
    right: -78px;
    top: 30px;
    width: 182px;
    height: 67px;
    font-family: OpenSans;
    font-size: 12px;
    line-height: 1.5;
    color: #666;
    padding: 15px 2px 12px 12px;
    border: 1px solid #b9b9b9;
    box-shadow: 0 1px 4px 0 rgba(185, 185, 185, 0.16),
        0 4px 12px 0 rgba(185, 185, 185, 0.5), 0 0 1px 0 #b9b9b9;
    border-radius: 15px;
    background-color: #fff;
    z-index: 2;
}

.sidebar .side-box .box-detail .detail-hint .icon_question span:before {
    content: "";
    position: absolute;
    display: inline-block;
    width: 10px;
    height: 10px;
    border-left: 1px solid #b9b9b9;
    border-top: 1px solid #b9b9b9;
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
    z-index: -1;
    background-color: #fff;
    top: -6px;
    right: 50%;
    margin-right: -10px;
}

.sidebar .side-box .box-detail .detail-hint > span {
    font-family: "OpenSans-Bold";
    font-weight: bold;
}
.sidebar .side-box .box-detail input {
    padding-left: 6px;
    width: 2.26rem;
    border-radius: 4px;
    height: 30px;
    box-sizing: border-box;
    border: 1px solid #b9b9b9;
    font-family: OpenSans;
    font-size: 12px;
    line-height: 1.07;
    color: #333;
}
.sidebar .side-box .box-detail input::placeholder {
    color: #b9b9b9;
}
.sidebar .side-box .box-detail input:focus {
    border-color: #3b6bbf;
}

.sidebar .side-box .box-detail .el-form-item__error {
    color: #bc3036;
    font-size: 12px;
}

.sidebar .side-box .box-detail button {
    font-weight: bold;
    width: 65px;
    height: 30px;
    padding: 0;
    background-color: #f5f9fd;
    color: #3b6bbf;
    border: 0;
}

.sidebar .side-box .box-detail button:hover {
    background-color: #99b2de;
    border-color: transparent;
    color: #123b82;
}

.sidebar .side-box .box-detail .subtotal .normal_subtotal p,
.sidebar .side-box .box-detail .subtotal .reduce_subtotal p {
    font-size: 14px;
    line-height: 1.71;
    color: rgb(155, 155, 155);
}

.sidebar .side-box .box-detail .subtotal .normal_subtotal p.strong,
.sidebar .side-box .box-detail .subtotal .reduce_subtotal p.strong {
    font-family: GothamBold;
    font-size: 14px;
    font-weight: bold;
}

.sidebar .side-box .box-detail .subtotal .reduce_subtotal .reduce_price {
    font-size: 14px;
    line-height: 1.71;
    color: rgb(192, 1, 9);
}
.sidebar
    .side-box
    .box-detail
    .subtotal
    .reduce_subtotal
    .reduce_price
    .strong {
    font-family: GothamBold;
    font-size: 14px;
    font-weight: bold;
    line-height: 1.71;
    text-align: right;
    color: rgb(192, 1, 9);
}

.sidebar .side-box .box-detail .subtotal .reduce_subtotal span {
    font-family: GothamBold;
    font-size: 12px;
    font-weight: bold;
    text-align: right;
    color: rgb(155, 155, 155);
}

.sidebar .side-box .box-detail .total p {
    font-size: 16px;
    line-height: 1.5;
    color: rgb(0, 0, 0);
}
.sidebar .side-box .box-detail .total p.strong {
    font-family: GothamBold;
    font-size: 18px;
    font-weight: bold;
    line-height: 1.33;
    color: #3b6bbf;
}
.sidebar .side-box .box-info .info-box {
    border: 2.5px solid #3b6bbf;
    padding: 20px 25px 25px 20px;
    margin: 21px 0;
    border-radius: 4px;
    cursor: pointer;
    position: relative;
}

.sidebar .side-box .box-info .info-box.info_checked {
    padding-bottom: 20px;
}
.sidebar .side-box .box-info .info-box.info_checked:after {
    content: "";
    position: absolute;
    right: 0;
    top: 0;
    background: url("../../../website_20/static/img/stacked-group-payment.svg")
        no-repeat;
    background-position: -256px -13px;
    width: 22px;
    height: 22px;
}

.sidebar .side-box .box-info .info-box .no_fee h5 {
    font-family: GothamBold;
    font-size: 13.6px;
    font-weight: 500;
    color: #3b6bbf;
}
/* .sidebar .side-box .box-info .info-box .no_fee p{

} */

.sidebar .side-box .box-info .info-box h5 {
    font-family: GothamBold;
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 7px;
    color: #333;
}
.sidebar .side-box .box-info .info-box p,
.sidebar .side-box .box-info .info-box .no_fee p {
    width: 1.825rem;
    font-family: OpenSans;
    font-size: 12px;
    line-height: 1.5;
    color: #666;
}
.sidebar .side-box .box-info .info-box p span {
    font-family: "OpenSans-Bold";
}
.sidebar .side-box .box-info .info-box .fr > i {
    position: relative;
}
.sidebar .side-box .box-info .info-box .fr > i:after {
    content: "";
    position: absolute;
    right: -10px;
    top: 24px;
    display: inline-block;
    width: 35px;
    height: 36.6px;
    background: url("../../../website_20/static/img/stacked-group-5.svg")
        no-repeat;
    background-position: 0 -30px;
}

.sidebar .side-box .box-info .info-box.info_checked .fr > i:after {
    right: 0;
    top: 32px;
    background-position: -62px -25px;
    width: 46px;
    height: 46px;
}

.sidebar .side-box .box-info .info-hint {
    font-family: OpenSans;
    font-size: 12px;
    font-style: italic;
    line-height: 1.33;
    padding-left: 25px;
    position: relative;
    color: #666;
}
.sidebar .side-box .box-info .info-hint:before {
    content: "";
    position: absolute;
    display: inline-block;
    left: 0;
    width: 15px;
    height: 15px;
    background: url("../../../website_20/static/img/stacked-group-payment.svg")
        no-repeat;
    background-position: -105px -15px;
}
.sidebar .next button {
    position: relative;
    width: 100%;
    background: #3b6bbf;
    box-shadow: 0 8px 15px 0 rgba(127, 156, 207, 0.5);
    color: #fff;
    font-family: GothamBold;
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 0.4px;
    height: 48px;
    border: 0;
}
.sidebar .next button:hover {
    background-color: #123b82;
}

.sidebar .next button.reserve:before {
    content: "";
    position: absolute;
    display: inline-block;
    left: 50%;
    top: 15px;
    margin-left: -85px;
    background: url("../../../website_20/static/img/stacked-group-payment@3x.png")
        no-repeat;
    background-size: contain;
    width: 18px;
    height: 18px;
}

.privacy_policy {
    margin: 15px 0;
}

.privacy_policy p {
    font-family: GothamBook;
    font-size: 12px;
    line-height: 1.33;
    text-align: center;
    color: #666;
}
.privacy_policy p a {
    color: #3b6bbf;
    text-decoration: underline;
}

.layout_left {
    padding-right: 27.5px;
}

.layout_right {
    padding-left: 27.5px;
}

@media (max-width: 768px) {
    .payment-main {
        padding: 25px 30px;
    }
    .layout_left {
        padding-right: 13px;
    }
    .layout_right {
        padding-left: 13px;
    }

    .sidebar .side-box,
    .sidebar .next {
        width: auto;
    }

    .sidebar .side-box {
        padding: 36px 20px;
    }
    .sidebar .side-box .box-detail input {
        width: 217px;
    }
}

@media (max-width: 414px) {
    .payment-main {
        padding: 25px 17px;
    }
    .layout_left {
        padding-right: 0;
    }
    .layout_right {
        padding-left: 0;
    }

    .payment-steps >>> .el-step__title {
        line-height: 1.29;
    }

    .sidebar .side-box .box-title p {
        width: auto;
    }

    .sidebar h3 {
        margin-top: 35px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/Reservation.vue